// @ts-nocheck

import { map as _map } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { ChevronRight, Close } from '../../assets/svg';
import { Target } from '../../client';
import { ZIndices } from '../../styled-components/dark/common';
import { FlashMessageSeverities } from '../../types/flashmessage';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';
import FlashMessage from '../FlashMessage';

const commonIcon = css`
  width: 1em;
  height: 1em;
  color: #fff;
`;

const CloseIcon = styled(Close)`
  ${commonIcon}
`;

const ArrowIcon = styled(ChevronRight)`
  ${commonIcon}
`;

const Message = styled.p`
  text-align: left;
  color: #fff;
  margin: 0 20px 0 0;
  text-shadow: 1px 1px 0 #000;
`;

const List = styled.div`
  right: 10px;
  width: 90%;
  z-index: ${ZIndices.tooltip};

  ${Target.__MOBILE__
    ? css`
        position: absolute;
        top: 10px;
        max-width: none;
      `
    : css`
        position: fixed;
        bottom: 10px;
        max-width: 300px;
      `}
`;

const FlashMessagesList = ({ delMessage, flashMessages }) => {
  const history = useHistory();

  const handleClickMsgBasket =
    ({ scope, id, severity }) =>
    () => {
      const isValidated = severity === FlashMessageSeverities.NOTICE;
      if (isValidated) {
        history.push(RoutesRedirectionFactory.getHistoryRouteConfig());
      }
      delMessage({ scope, id });
    };

  const handleDeleteMsgBasket =
    ({ scope, id }) =>
    () => {
      delMessage({ scope, id });
    };

  const renderMessageBasket = (message) => {
    const isValidated = message.severity === FlashMessageSeverities.NOTICE;
    return (
      <FlashMessage
        key={message.id}
        severity={message.severity}
        handleDelete={handleDeleteMsgBasket(message)}
        handleClick={handleClickMsgBasket(message)}
      >
        <Message>{message.message}</Message>
        {isValidated ? <ArrowIcon /> : <CloseIcon />}
      </FlashMessage>
    );
  };

  return <List>{flashMessages && flashMessages.BASKET ? _map(flashMessages.BASKET, renderMessageBasket) : null}</List>;
};

export default FlashMessagesList;
